import { useHistory, useLocation } from 'react-router-dom';
import Container from '~/components/container';
import * as St from '../Detail/styles';
import ContainerFlex from '~/components/containerFlex';
import TitleApp from '~/components/title';
import moment from 'moment';
import Button from '~/components/button';
import useApi from '~/hooks/useApi';
import Loading from '~/components/loading';
import Endpoints from '~/services/endpoints';
export default function FutureInvoices() {
  const history = useHistory();
  const { state } = useLocation<{
    numeroCartao: string;
  }>();
  const { data, loading } = useApi({
    url: Endpoints.consult.getClientInvoices,
    body: { numeroCartao: state?.numeroCartao?.replaceAll('.', '') },
    enabled: !!state?.numeroCartao,
  });

  const faturas = data?.data?.faturasFuturas || [];
  return (
    <div>
      <Loading status={loading} />
      <Container>
        <St.BoxCard>
          <ContainerFlex>
            <ContainerFlex padding={26}>
              <TitleApp>Faturas futuras</TitleApp>
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex>
            {faturas?.toReversed()?.map((fatura, index) => (
              <St.InvoiceGridList
                key={index}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  history.push('/invoice/detail/extract', {
                    numeroCartao: state.numeroCartao,
                    dataReferencia: fatura?.dtVencimento,
                    faturaFutura: true,

                    fatura: fatura,
                  });
                }}
              >
                <span>Fatura</span>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>
                    {moment(fatura?.periodo, 'yyyy-MM')
                      .toDate()
                      .toLocaleString('pt-BR', {
                        month: 'long',
                      })
                      .toUpperCase()}{' '}
                    DE {moment(fatura?.periodo, 'yyyy-MM').format('YYYY')}
                  </span>
                  <span>R$: {fatura.valor.toFixed(2)}</span>
                </div>
              </St.InvoiceGridList>
            ))}
          </ContainerFlex>
          <ContainerFlex marginTop={24} padding={16}>
            <Button fitContent onClick={() => history.goBack()}>
              Voltar
            </Button>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </div>
  );
}
